/**
 * Open links to YouTube/Vimeo videos in modal overlay/lightbox
 */

import $ from 'jquery';

export const videolink = () => {
    const $linkedVideo = $('.ghwp-video-link');

    if ($linkedVideo.length) {
        $linkedVideo.magnificPopup({
            type: 'iframe',
            disableOn: 576,
            mainClass: 'mfp-fade',
            preloader: false,
            fixedContentPos: false,
            removalDelay: 160,
            iframe: {
                patterns: {
                    youtube: {
                        id: function(url) {
                            const isYT = url.match(
                                /https?:\/\/(?:www\.)?youtube\.com\/watch\?(?:[^\s&?]*)*(?:&?v=([^&?\s]*))(?:&[^\s&?]*)*/
                            );
                            return (isYT && isYT[1]) || '';
                        },
                        src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
                    },
                },
            },
        });
    }
};
